import React, { useCallback } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useFormik } from 'formik'
import { useDispatch } from 'react-redux'
import { useRequests } from '../requests/useRequests'
import { RefreshActions } from '../state/refresh'
import { Contract } from '../types/contracts'
import { InputLabel, Select, MenuItem, FormControl } from '@mui/material'
import { Contractor } from '../types/contractor'

interface NewOrEditContractDialogProps {
  contract: Contract | null
  contractors: Contractor[]
  handleClose: (b: boolean) => void
}

const NewOrEditContractDialog = ({
  contract,
  contractors,
  handleClose
}: NewOrEditContractDialogProps): JSX.Element => {
  const dispatch = useDispatch()
  const requestMaker = useRequests()

  const initContract = {
    id: contract?.id,
    unitNetto: contract?.unitNetto,
    vatRate: contract?.vatRate,
    contractorId: contract?.contractorId,
    quantity: contract?.quantity,
    service: contract?.service
  }

  const validate = (contract: Partial<Contract>): Partial<Contract> => {
    const errors: typeof contract = {}

    return errors
  }

  const onSubmit = useCallback(
    async (contract: Partial<Contract>): Promise<void> => {
      handleClose(true)
      const isEdited = contract.id !== undefined

      if (isEdited) {
        await requestMaker.updateContract(contract)
      } else {
        await requestMaker.createContract(contract)
      }
      dispatch(RefreshActions.refreshUserState())
    },
    [requestMaker, dispatch, handleClose]
  )

  const formik = useFormik({
    initialValues: initContract,
    onSubmit,
    enableReinitialize: true,
    validate
  })

  return (
    <div>
      <Dialog open onClose={handleClose}>
        <form>
          <DialogTitle>Contract</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin='dense'
              id='unitNetto'
              label='Unit netto'
              type='number'
              fullWidth
              variant='standard'
              value={formik.values.unitNetto}
              onChange={formik.handleChange}
            />
            <TextField
              margin='dense'
              id='vatRate'
              label='Vat rate'
              type='number'
              fullWidth
              variant='standard'
              value={formik.values.vatRate}
              onChange={formik.handleChange}
            />
            <TextField
              margin='dense'
              id='quantity'
              label='Quantity'
              type='number'
              fullWidth
              variant='standard'
              value={formik.values.quantity}
              onChange={formik.handleChange}
            />
            <TextField
              margin='dense'
              id='service'
              label='Service'
              type='name'
              fullWidth
              variant='standard'
              value={formik.values.service}
              onChange={formik.handleChange}
            />
            {/* <TextField
              margin='dense'
              id='contractorId'
              label='Contractor id'
              type='number'
              fullWidth
              variant='standard'
              value={formik.values.contractorId}
              onChange={formik.handleChange}
            /> */}
            <FormControl fullWidth style={{ marginTop: '1vw' }}>
              <InputLabel id='contractorId'>Contractor</InputLabel>
              <Select
                labelId='contractorId'
                id='contractorId'
                value={
                  contractors.find(c => c.id === formik.values.contractorId)?.id
                }
                label='Contractor'
                onChange={e => {
                  void formik.setFieldValue('contractorId', e.target.value)
                }}
              >
                {contractors?.map((c, index) => (
                  <MenuItem key={index} value={c.id}>
                    {c.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose as any}>Cancel</Button>
            <Button onClick={formik.handleSubmit as any}>Add</Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}

export default NewOrEditContractDialog
